var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAbkhazia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1964 4.5715C24.3106 1.744 20.3595 0 16.0003 0C14.609 0 10.5382 1.744 7.6525 4.5715H27.1964Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0005 13.7143H31.8372C31.6063 12.1002 31.1349 10.5639 30.4598 9.14282H15.3048L16.0005 13.7143Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54068 22.8571H30.4593C31.1344 21.4361 31.6059 19.8997 31.8367 18.2856H0.163239C0.394176 19.8998 0.865488 21.4361 1.54068 22.8571Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80386 27.4285C7.68968 30.256 11.6408 32 16 32C20.3592 32 24.3103 30.256 27.1961 27.4285H4.80386Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.93961 0 1.27249 5.96069 0.163239 13.7143H16V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00025 12.2666L7.30463 10.8754V8.09273L9.04375 6.70142L10.7829 8.09273V10.1797L11.4785 9.48404V10.8754L10.0872 12.2666H8.00025Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2587 8L4.44289 8.56688H5.03889L4.5567 8.91731L4.74095 9.48413L4.2587 9.13375L3.77645 9.48413L3.9607 8.91731L3.47852 8.56688H4.07452L4.2587 8Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6503 6.60864L5.83449 7.17552H6.43055L5.9483 7.52596L6.13249 8.09277L5.6503 7.74246L5.16812 8.09277L5.35237 7.52596L4.87012 7.17552H5.46605L5.6503 6.60864Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04093 5.21729L7.22512 5.78416H7.82105L7.33893 6.1346L7.52305 6.70141L7.04093 6.3511L6.55868 6.70141L6.74287 6.1346L6.26074 5.78416H6.85668L7.04093 5.21729Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8288 8L13.6446 8.56688H13.0486L13.5308 8.91731L13.3466 9.48413L13.8288 9.13375L14.311 9.48413L14.1268 8.91731L14.609 8.56688H14.013L13.8288 8Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4374 6.60864L12.2533 7.17552H11.6573L12.1394 7.52596L11.9553 8.09277L12.4374 7.74246L12.9197 8.09277L12.7354 7.52596L13.2176 7.17552H12.6217L12.4374 6.60864Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0458 5.21729L10.8616 5.78416H10.2656L10.7478 6.1346L10.5636 6.70141L11.0458 6.3511L11.528 6.70141L11.3438 6.1346L11.8259 5.78416H11.23L11.0458 5.21729Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04377 4.52173L8.85952 5.0886H8.26358L8.74571 5.43898L8.56152 6.00579L9.04377 5.65548L9.52596 6.00579L9.34177 5.43898L9.82389 5.0886H9.22796L9.04377 4.52173Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAbkhazia);
export default __webpack_public_path__ + "static/media/flag_abkhazia.29e3e16c6d1403de94dbdd911e4022ef.svg";
export { ForwardRef as ReactComponent };